<button
	class="button-custom"
	type="button"
	[ngClass]="buttonClassSignal()"
	[disabled]="loading$ | async"
	(click)="onClick()"
>
	<div class="button-content">
		<div class="left-content">
			<app-icon *ngIf="icon" class="icon" [iconName]="icon" />
			<span class="text-left">{{ text }}</span>
		</div>

		<ion-spinner *ngIf="loading$ | async" name="crescent" class="button-spinner" />
	</div>
</button>
